module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-08-24 at 14.53.06.08ab1eb1.png";